import React from "react";
import { X } from "lucide-react";

const DetailItem = ({ label, value }) => (
  <div>
    <p className="text-sm text-[#6B7280]">{label}</p>
    <p className=" text-sm font-medium text-[#1D2026]">{value}</p>
  </div>
);

const SessionDetailsModal = ({ open, session, onClose, onJoinMeeting }) => {
  if (!open || !session) return null;

  const handleCopyLink = async () => {
    if (!session.meetingLink) return;

    try {
      await navigator.clipboard.writeText(session.meetingLink);
    } catch (error) {
      console.error("Failed to copy meeting link:", error);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="font-['Roboto'] max-h-[90vh] w-full max-w-[672px] overflow-y-auto rounded-lg  bg-white py-6">
        <div className="flex items-center justify-between border-b border-[#E5E7EB] pb-8 px-6">
          <h2 className="text-lg font-semibold text-[#111827]">
            Session Details
          </h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close session details"
            className="text-[#1D2026] transition-opacity hover:opacity-70"
          >
            <X size={24} />
          </button>
        </div>

        <div className="px-6">
          <h3 className="text-base font-semibold text-[#111827]">
            Session Information
          </h3>

          <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2">
            <DetailItem label="Session ID" value={session.sessionId} />
            <DetailItem label="Type" value={session.type} />
            <DetailItem label="Category" value={session.category} />
            <DetailItem label="Level" value={session.level} />
            <DetailItem label="Sub Category" value={session.subCategory} />
            <DetailItem label="Age Group" value={session.ageGroup} />
            <DetailItem label="Course" value={session.course} />
            <DetailItem label="Time" value={session.time} />
            <DetailItem label="Date" value={session.date} />
          </div>

          <h2 className="mt-6 text-base font-semibold text-[#111827]">
            Instructor Details
          </h2>
          <div className="mt-3 bg-[#F5F5F5] rounded-lg grid grid-cols-1 gap-4 sm:grid-cols-2 pt-4 px-4 pb-6">
            <DetailItem label="Name" value={session.instructorName} />
            <DetailItem label="Email" value={session.instructorEmail} />
          </div>
 {session.meetingLink && (
      <>
          <h2 className="mt-6 text-base font-semibold text-[#111827]">
            Meeting Information
          </h2>
        
          <div className="mt-3 bg-[#EFF6FF] rounded-lg flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between p-4">
            <div>
              <p className="text-sm text-[#6B7280]">Meeting Link:</p>
              <a
                href={session.meetingLink}
                target="_blank"
                rel="noreferrer"
                className=" break-all block  text-base font-medium text-[#2563EB]"
              >
                {session.meetingLink}
              </a>
            </div>
            <button
              type="button"
              onClick={handleCopyLink}
              className="rounded bg-[#2563EB] px-3 py-1 text-sm text-white transition-colors hover:bg-[#0789af]"
            >
              Copy Link
            </button>
          </div>
          </>
          )}

          <div className="mt-3 flex justify-end gap-3 border-t border-[#E5E7EB] pt-[22px]">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border border-[#D1D5DB] px-6 py-[9px] text-base  text-[#374151] transition-colors hover:bg-[#F5F5F5]"
            >
              Close
            </button>
            {session.meetingLink && (
            <button
              type="button"
              onClick={onJoinMeeting}
              className="rounded-lg bg-[#FF6636] px-6 py-[9px] text-base text-white transition-colors hover:bg-[#e65a2e]"
            >
              Join Meeting
            </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionDetailsModal;
